import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {createJobLoadEntry, getJobLoads, updateJobLoadEntry, voidJobLoadEntry} from './api'
import {jobLoadsKeys} from './query-keys'
import type {LoadEntryInput} from './schemas'

export function useJobLoads(jobId: string) {
    return useQuery({queryKey: jobLoadsKeys.forJob(jobId), queryFn: () => getJobLoads(jobId)})
}

export function useSaveJobLoadEntry(jobId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({entryId, input}: {entryId: string | null; input: LoadEntryInput}) =>
            entryId == null
                ? createJobLoadEntry(jobId, input)
                : updateJobLoadEntry(jobId, entryId, input),
        onSuccess: (loads) => {
            queryClient.setQueryData(jobLoadsKeys.forJob(jobId), loads)
        },
    })
}

export function useVoidJobLoadEntry(jobId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: ({entryId, reason}: {entryId: string; reason: string}) =>
            voidJobLoadEntry(jobId, entryId, reason),
        onSuccess: (loads) => {
            queryClient.setQueryData(jobLoadsKeys.forJob(jobId), loads)
        },
    })
}
